import { IV3D } from '@/Interfaces/v3d';
import { Vector3, Quaternion } from 'three';
import { V3dTools } from '@/v3d/common';
import { doorDepth, doorOffset } from '@/Constants/common';
import { v3dMesh, xyz } from '@/Interfaces/common';
import { $ } from '@/Engine/stateInstance';
import { WardrobeObject } from '@/Engine/Wardrobe/WardrobeObject';

declare let v3d: IV3D;
export interface DoorProps {
    width: number;
    height: number;
    name: string;
    uuid: string
}

export class Door extends WardrobeObject {
    private v3dTools: V3dTools;
    name: string;
    _model: v3dMesh | null = null;

    get startPoint(): xyz {
        return [
            -this.width/2,
            0.01,
            0,
        ];
    }

    set position(pos: Vector3) {
        // this.model.position.copy({ ...pos, y: 0});
        this.model.position.x = pos.x;
        this.model.position.y = 0.01;
        this.model.position.z = pos.z;
        this.updateModelShapeKey();
        this.computeObb();
    }

    get position() {
        return this.model.position;
    }

    constructor({ width, height, name, uuid } : DoorProps) {
        super({ width, height, depth: doorDepth, uuid, type: 'door' });
        this.name = name;
        this.v3dTools = $.v3dTools;

        const model = this.v3dTools.getObjectByName(name);
        // this.model = new Group();
        this.model.userData.parent = this;

        if (!model) {
            console.error('Не найдена модель двери ' + name);
            return;
        }

        this._model = model.clone() as v3dMesh;
        this._model.visible = true;
        this._model.position.set(...doorOffset);
        this._model.userData.parent = this;
        this.model.add(this._model);

        this.updateModelShapeKey();
    }

    updateModelShapeKey() {
        if (!this._model) return;

        this.v3dTools.setMorphFactorByItem(
            this._model,
            'height',
            this.height - 2,
        );
        this.v3dTools.setMorphFactorByItem(
            this._model,
            'width',
            this.width - 0.9,
        );
        this._updateBox();
    }

    setPosition(position: Vector3) {
        this.position = position;
        this._updateBox();
    }

    setDimensions(width: number, height: number) {
        this.width = width;
        this.height = height;
        this.updateModelShapeKey();
    }

    // select() {
    //     this.selectionBox = selectionBox;
    //     selectionBox.select(this);
    //     this.model.add(selectionBox.model);
    // }

    // unselect() {
    //     selectionBox.unselect();
    //     this.selectionBox = null;
    // }

    _updateBox() {
        if (!this.model.parent) return;

        this.box.makeEmpty();
        const dimesnions = new Vector3(this.width, this.height, this.depth);
        const quatern = new Quaternion();
        this.model.getWorldQuaternion(quatern);
        dimesnions.applyQuaternion(quatern);
        dimesnions.x = Math.abs(dimesnions.x);
        dimesnions.y = Math.abs(dimesnions.y);
        dimesnions.z = Math.abs(dimesnions.z);
        const worldPosition = new Vector3();
        this.model.getWorldPosition(worldPosition);
        worldPosition.y += this.height/2;
        this.box.setFromCenterAndSize(worldPosition, dimesnions);
    }

    computeObb() {
        const worldQuaternion = new Quaternion();
        this.model.getWorldQuaternion(worldQuaternion);
        const centerShift = new Vector3(0,+this.height/2, this.depth/2).applyQuaternion(worldQuaternion);
        this.worldBox = this.box.clone().applyMatrix4(this.model.matrixWorld);
        super.computeObb(centerShift, 0.0001);
    }

}
